import { ReactComponent as IconTable } from 'assets/images/icon-table.svg';
import { forwardRef } from 'react';
import DineinMenu from './DineinMenu';

const DineinSelectBox = forwardRef(
  (
    {
      orderType,
      currentOrder,
      floorsData,
      selectedTable,
      showAccordion,
      storeId,
      toggleAccordion,
      showErrorInTableSelector,
      selectTable,
    },
    ref
  ) => {
    // const { floorLayoutId, dineInObjectId } = currentOrder;
    // useEffect(() => {
    //   if (!floorLayoutId || !dineInObjectId || !storeId) return;

    //   fetchDineinTableAndOrder({ floorLayoutId, dineInObjectId, storeId });
    //   //   eslint-disable-next-line
    // }, [floorLayoutId, dineInObjectId, storeId]);

    return (
      orderType === '3' &&
      (Object.keys(floorsData)?.length > 0 ? (
        <div
          className={`${
            showErrorInTableSelector ? `pickupbox error` : `pickupbox`
          }`}
        >
          <div className='tablesBoxInner'>
            <div
              className='tablesAccordionWrap'
              onClick={(e) => toggleAccordion(e, true)}
            >
              <div className='pickImg'>
                <IconTable />
              </div>
              <div
                className={`${
                  showErrorInTableSelector ? `tablesName error` : `tablesName`
                }`}
              >
                {selectedTable?.name || selectedTable?.number
                  ? `Table ${selectedTable?.name || selectedTable?.number}`
                  : 'Select Table'}
                <span
                  className={
                    showAccordion
                      ? 'rotateAccordion rotateAccordion--active'
                      : 'rotateAccordion'
                  }
                >
                  <i className='thickcon-Up-Chevron' />
                </span>
              </div>
            </div>
            <div
              className={
                showAccordion ? 'accordionMain active' : 'accordionMain'
              }
              ref={ref}
            >
              <div className='tabWrapMain'>
                <DineinMenu
                  floorsData={floorsData}
                  currentOrder={currentOrder}
                  selectTable={selectTable}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <p className='tablesBoxInner__no-tables'>No tables available.</p>
      ))
    );
  }
);

export default DineinSelectBox;
